/* eslint-disable react/prop-types */
import React from "react";

function AvailabilitySlot({
  slot,
  date,
  formattedDate,
  period,
  showAllSlots,
  selectedSlot,
  onSlotClick,
  isUrgentDay,
  appointmentData,
}) {
  const utilisationPercentage =
    slot?.capacity === 0
      ? 0
      : Math.ceil((1 - slot.available / slot.capacity) * 100);
  const isSelected = selectedSlot === `${formattedDate}-${period}`;

  if (
    (!showAllSlots && !slot.recommended && !isUrgentDay) ||
    (slot.available <= 0 && !isUrgentDay) ||
    slot.capacity <= 0
  ) {
    return null;
  }

  return (
    <button
      type="button"
      className={`slot-card ${period.toLowerCase()} ${
        isSelected ? "selected" : ""
      }`}
      onClick={() => onSlotClick(date, formattedDate, period)}
    >
      <div
        className="slot-info"
        data-testid={`slot-info-${formattedDate}-${period.toLowerCase()}`}
      >
        <span className="slot-info-period">
          {period === "AM" ? "☀️" : "🌙"}
        </span>
        <span className="slot-info-period">{period}</span>
        {slot.recommended && <div className="recommended-label">ON-SITE</div>}
        {isUrgentDay && <div className="urgent-label">Reminder - SLA hours: {appointmentData.slahours}</div>}
        <span>Available: {slot.available}</span>
        <div
          className={`capacity-bar ${
            slot.available < 0 ? "capacity-bar-red" : ""
          }`}
          data-testid={`capacity-bar-${formattedDate}-${period.toLowerCase()}`}
          style={{ "--used-percentage": `${utilisationPercentage}%` }}
        />
      </div>
    </button>
  );
}

export default AvailabilitySlot;
